<template>
  <div>
    <b-modal
      ref="modal"
      :title="'Lançar Contas'"
      header-class="border-bottom-0"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <!-- <select-input v-model="form.account.value" :alias="form.account.alias" :options="form.account.options" /> -->
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-12">Compra #{{ purchase.number }}</div>
        </div>
        <br />
      </div>

      <div slot="modal-footer">
        <button
          role="button"
          class="btn btn-outline-secondary"
          @click="$refs.modal.hide()"
        >
          <i class="fas fa-times"></i> Cancelar
        </button>
        <button
          role="button"
          class="btn btn-success"
          style="margin-left: 5px"
          @click="store"
        >
          <i class="fas fa-check"></i> Lançar Contas
        </button>
      </div>

      <error-handler :error="error" />
    </b-modal>
  </div>
</template>

<script>

import Filters from "@/mixins/Filters.js";

export default {
  data: function () {
    return {
      purchase: {},

      error: null,
    };
  },
  methods: {
    open(purchase) {
      this.error = null

      this.purchase = purchase;
      this.$refs.modal.show();
    },

    async store() {
      this.error = null

      let params = { id : this.purchase.id }
      
      this.$store.commit("showLoading");
      
      await this.$store.dispatch("purchase/postEmitPurchaseBill", params)
        .then(response => {
          
          this.$refs.modal.hide();
        
          this.$emit("store");
        
        })
        .catch(error => {
          this.error = error
        })
      
      this.$store.commit("hideLoading");

    },
  },
};
</script>

<style>
</style>
